import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { pxToRem } from "../../../styles/utils";

export const ButtonContainer = styled.div<{ noLessons?: boolean }>`
  display: flex;
  justify-content: start;
  align-items: center;
  padding: ${pxToRem(6)} ${pxToRem(12)};
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgb(226, 226, 226);
  border-radius: ${pxToRem(8)};
  background: rgb(250, 250, 250);
  gap: ${pxToRem(6)};
  cursor: pointer;
  width: fit-content;

  &:hover {
    background-color: rgb(243, 243, 243);
  }

  ${({ noLessons }) =>
    noLessons &&
    css`
      // cursor: default;
      // border: none;
      
      // &:hover {
      //   background-color: rgb(250, 250, 250); /* Отключаем hover */
      // }
    `}
`;

export const ButtonIcon = styled.img`
  width: ${pxToRem(22.5)};
  height: ${pxToRem(15)};
  color: rgb(122, 92, 224);
`;

export const ButtonText = styled.span`
  font-size: ${pxToRem(16)};
  font-weight: 500;
  color: rgb(31, 10, 53);
  text-decoration: none;
  white-space: nowrap;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
